/**
 * MusicPortfolioPage — links to the SoundCloud profile that holds the
 * music portfolio.  Studio-themed page reachable from the NavPane
 * (per user iter 134).
 */
import { useNavigate } from "react-router-dom";
import TopBar from "@/components/TopBar";
import NavPane from "@/components/NavPane";
import { SoundcloudIcon } from "@/components/SocialIcons";

const PAL = {
  bg: "#0F0E0C",
  ink: "#F5F1E8",
  muted: "#9C8E72",
  accent: "#E5C870",
  border: "rgba(229,200,112,0.18)",
};
const TIMES = "'Times New Roman',Times,serif";
const SOUNDCLOUD_URL = "https://soundcloud.com/andrewgreenofficial";

export default function MusicPortfolioPage() {
  const navigate = useNavigate();
  return (
    <div
      className="min-h-screen"
      style={{ background: PAL.bg, color: PAL.ink }}
      data-testid="music-portfolio-page"
    >
      <TopBar
        theme="studio"
        onBack={() => navigate("/")}
        backLabel="HOME"
        testId="music-portfolio-back-button"
      />
      <div className="relative z-10 max-w-7xl mx-auto flex flex-col md:flex-row">
        <div
          className="md:w-[260px] md:shrink-0 md:min-h-screen flex flex-col pt-4 md:pt-6 px-4 md:px-6 pb-6 md:border-r"
          style={{ borderColor: PAL.border }}
        >
          <NavPane theme="studio" />
        </div>
        <main className="flex-1 flex flex-col pt-4 md:pt-6 px-6 md:px-12 pb-10">
          <div className="max-w-3xl">
            <h1
              className="leading-[1.02] mb-7"
              style={{
                fontFamily: TIMES,
                fontWeight: 500,
                color: PAL.accent,
                fontSize: "clamp(2.4rem, 5vw, 5rem)",
                letterSpacing: "0.005em",
                textShadow:
                  "0 2px 0 rgba(0,0,0,0.55), 0 0 28px rgba(229,200,112,0.22)",
              }}
              data-testid="music-portfolio-title"
            >
              Music Portfolio
            </h1>
            <p
              className="mb-6 text-base"
              style={{
                fontFamily: TIMES,
                color: "#BAB09A",
                lineHeight: 1.65,
              }}
              data-testid="music-portfolio-blurb"
            >
              The full collection of my music &mdash; original compositions,
              soundscapes, and instrumental sketches &mdash; lives on
              SoundCloud.
            </p>
            <a
              href={SOUNDCLOUD_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-4 py-3 rounded-sm border transition-all"
              style={{
                borderColor: "rgba(229,200,112,0.3)",
                color: PAL.accent,
                fontFamily: TIMES,
                letterSpacing: "0.04em",
                textDecoration: "none",
                fontSize: "12pt",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "#F5D98A";
                e.currentTarget.style.borderColor = "rgba(229,200,112,0.7)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = PAL.accent;
                e.currentTarget.style.borderColor = "rgba(229,200,112,0.3)";
              }}
              data-testid="music-portfolio-soundcloud-link"
            >
              <SoundcloudIcon size={22} />
              <span>{SOUNDCLOUD_URL}</span>
            </a>
          </div>
        </main>
      </div>
    </div>
  );
}
